export var BiscuitsErrorCode;
(function (BiscuitsErrorCode) {
    BiscuitsErrorCode[BiscuitsErrorCode["BadRequest"] = 4000] = "BadRequest";
    BiscuitsErrorCode[BiscuitsErrorCode["UnrecognizedApp"] = 4001] = "UnrecognizedApp";
    BiscuitsErrorCode[BiscuitsErrorCode["Unauthorized"] = 4010] = "Unauthorized";
    BiscuitsErrorCode[BiscuitsErrorCode["NotLoggedIn"] = 4011] = "NotLoggedIn";
    BiscuitsErrorCode[BiscuitsErrorCode["SessionExpired"] = 4012] = "SessionExpired";
    // requires re-login
    BiscuitsErrorCode[BiscuitsErrorCode["SessionInvalid"] = 4013] = "SessionInvalid";
    BiscuitsErrorCode[BiscuitsErrorCode["Forbidden"] = 4030] = "Forbidden";
    BiscuitsErrorCode[BiscuitsErrorCode["NoPlan"] = 4031] = "NoPlan";
    BiscuitsErrorCode[BiscuitsErrorCode["SubscriptionInactive"] = 4032] = "SubscriptionInactive";
    BiscuitsErrorCode[BiscuitsErrorCode["PlanFull"] = 4033] = "PlanFull";
    BiscuitsErrorCode[BiscuitsErrorCode["NotFound"] = 4040] = "NotFound";
    BiscuitsErrorCode[BiscuitsErrorCode["Conflict"] = 4090] = "Conflict";
    BiscuitsErrorCode[BiscuitsErrorCode["RateLimited"] = 4290] = "RateLimited";
    BiscuitsErrorCode[BiscuitsErrorCode["UsageLimitReached"] = 4291] = "UsageLimitReached";
    BiscuitsErrorCode[BiscuitsErrorCode["Unexpected"] = 5000] = "Unexpected";
})(BiscuitsErrorCode || (BiscuitsErrorCode = {}));
export class BiscuitsError extends Error {
    static readResponse(response) {
        const code = response.headers.get('x-biscuits-error');
        const message = response.headers.get('x-biscuits-message');
        if (code && message) {
            return new BiscuitsError(parseInt(code), message);
        }
        return null;
    }
    static readResponseBody(body) {
        let parsed = body;
        if (typeof body === 'string') {
            parsed = JSON.parse(body);
        }
        if ('code' in parsed && 'message' in parsed) {
            return new BiscuitsError(parsed.code, parsed.message);
        }
        return null;
    }
    static isInstance(err) {
        return (err instanceof BiscuitsError || (err === null || err === void 0 ? void 0 : err.isBiscuitsError) === true);
    }
    constructor(code, message, cause, extraData) {
        super(message, {
            cause,
        });
        this.extraData = extraData;
        this.isBiscuitsError = true;
        this.name = 'BiscuitsError';
        this.code = code;
        this.message = message || `BiscuitsError: ${code}`;
    }
    get statusCode() {
        return Math.floor(this.code / 10);
    }
    get body() {
        return { code: this.code, message: this.message };
    }
    get headers() {
        return {
            'x-biscuits-error': this.code.toString(),
            'x-biscuits-message': this.message,
        };
    }
}
BiscuitsError.Code = BiscuitsErrorCode;
//# sourceMappingURL=index.js.map